var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4226 24.132C21.3702 24.132 22.9491 22.5531 22.9491 20.6055C22.9491 18.6578 21.3702 17.079 19.4226 17.079C17.475 17.079 15.8961 18.6578 15.8961 20.6055C15.8961 22.5531 17.475 24.132 19.4226 24.132Z",
    fill: "#61DAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4226 27.8305C29.8733 27.8305 38.3453 24.5957 38.3453 20.6054C38.3453 16.6152 29.8733 13.3804 19.4226 13.3804C8.97196 13.3804 0.5 16.6152 0.5 20.6054C0.5 24.5957 8.97196 27.8305 19.4226 27.8305Z",
    stroke: "#61DAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1656 24.218C18.391 33.2685 25.4283 38.9881 28.884 36.993C32.3397 34.9978 30.9051 26.0435 25.6797 16.993C20.4544 7.9424 13.417 2.22284 9.96134 4.21797C6.50567 6.21311 7.94028 15.1674 13.1656 24.218Z",
    stroke: "#61DAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1657 16.993C7.94036 26.0436 6.50575 34.9979 9.96142 36.993C13.4171 38.9881 20.4544 33.2686 25.6798 24.218C30.9051 15.1674 32.3397 6.21313 28.8841 4.218C25.4284 2.22287 18.391 7.94243 13.1657 16.993Z",
    stroke: "#61DAFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactLogo);
export default __webpack_public_path__ + "static/media/react-logo.5ba48f79b797508a2dd8acdfee2cd125.svg";
export { ForwardRef as ReactComponent };